(() => {
  const emit = (name, data) => {
    if (!window.Shopify?.analytics?.publish) return false;
    try { window.Shopify.analytics.publish(name, data); return true; } catch { return false; }
  };
  const updateLinks = () => {
    document.querySelectorAll('[data-veroak-product]').forEach((box) => {
      const section = box.closest('product-info');
      const options = section?.querySelectorAll('variant-selects input[type=radio]:checked,variant-selects select option:checked') || [];
      const colour = [...new Set(Array.from(options, (option) => option.value))].join(' / ') || box.dataset.defaultColour || '';
      const quantity = section?.querySelector('input[name="quantity"]')?.value || '';
      const text = ['Hello Veroak Leather,', `Product: ${box.dataset.productName}`, `Model: ${box.dataset.model}`, `URL: ${box.dataset.productUrl}`, `Colour: ${colour}`, `Quantity: ${quantity}`, 'Delivery country:', 'Enquiry: Wholesale pricing / product question'].join('\n');
      const link = box.querySelector('[data-veroak-whatsapp]');
      if (link) link.href = `https://wa.me/8613416287931?text=${encodeURIComponent(text)}`;
      const enquiry = box.querySelector('[data-veroak-contact-link]');
      if (enquiry) {
        const url = new URL(enquiry.href, location.origin);
        url.searchParams.set('colour', colour);
        if (quantity) url.searchParams.set('quantity', quantity);
        enquiry.href = url.href;
      }
    });
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-veroak-whatsapp]');
    if (!link) return;
    updateLinks();
    emit('veroak:whatsapp_clicked', { product_handle: link.closest('[data-veroak-product]')?.dataset.veroakProduct || null, path: location.pathname });
  });
  document.addEventListener('change', updateLinks);
  document.addEventListener('input', (event) => {
    if (event.target.matches('product-info input[name="quantity"]')) updateLinks();
  });
  document.addEventListener('product-info:loaded', updateLinks);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => { updateLinks(); requestAnimationFrame(updateLinks); });
  updateLinks();
  const params = new URLSearchParams(location.search);
  const type = document.getElementById('VeroakType');
  const models = document.getElementById('VeroakModels');
  const quantity = document.getElementById('VeroakQuantity');
  const message = document.getElementById('VeroakMessage');
  if (type && ['Retail', 'Wholesale'].includes(params.get('enquiry'))) type.value = params.get('enquiry');
  if (models && params.has('model')) models.value = params.get('model').slice(0, 200);
  if (quantity && /^[1-9]\d{0,6}$/.test(params.get('quantity') || '')) quantity.value = params.get('quantity');
  if (message && !message.value && params.has('colour')) message.value = `Colour: ${params.get('colour').slice(0, 100)}\n`;
  const form = document.getElementById('VeroakContact');
  if (!form) return;
  form.addEventListener('submit', () => {
    try { sessionStorage.setItem('veroak-enquiry-attempt', JSON.stringify({ id: crypto.randomUUID(), type: type?.value || 'Retail', time: Date.now() })); } catch {}
  });
  const success = form.querySelector('[data-veroak-enquiry-success]');
  if (!success) return;
  success.focus();
  const recordSuccess = () => {
    try {
      const pending = JSON.parse(sessionStorage.getItem('veroak-enquiry-attempt') || 'null');
      if (!pending) return;
      if (Date.now() - pending.time > 30 * 60 * 1000) { sessionStorage.removeItem('veroak-enquiry-attempt'); return; }
      if (emit('veroak:enquiry_submitted', { enquiry_type: pending.type, submission_id: pending.id })) sessionStorage.removeItem('veroak-enquiry-attempt');
    } catch {}
  };
  recordSuccess();
  window.addEventListener('load', recordSuccess, { once: true });
})();
